export enum Action {
  AddAll = 'add-all',
  RemoveAll = 'remove-all',
}

export type SelectType = 'locations' | 'products' | 'salespersons';
